import React from "react";

const RadioInput = ({
  label,
  options,
  name,
  onChange,
  required,
  checked,
  disabled,
}) => {
  return (
    <div>
      {label && (
        <label
          htmlFor={name}
          className="text-gray-700 mb-2 font-regular flex items-center text-sm"
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <div className="flex items-center gap-4">
        {options.map(({ label, value }) => (
          <label
            htmlFor={label}
            key={label}
            className="flex items-center gap-2 text-gray-700"
          >
            <input
              id={label}
              type="radio"
              name={name}
              value={value}
              checked={value === checked}
              disabled={disabled}
              onChange={(e) => onChange(name, e.target.value)}
            />
            {label}
          </label>
        ))}
      </div>
    </div>
  );
};

export default RadioInput;
